<script lang="ts" setup>
import { fortnoxAuthService } from '@/services/auth/fortnox-auth-service';
import { onMounted, ref } from 'vue';
import FortnoxAccountHandlerView from './FortnoxAccountHandlerView.vue';
import { useFortnoxAccountHandlerLogic } from './fortnox-account-handler-logic';

const authenticated = ref(fortnoxAuthService.authenticated);
const account = ref<Awaited<
  ReturnType<typeof fortnoxAuthService.getMe>
> | null>(null);

const loadData = async () => {
  account.value = await fortnoxAuthService.getMe();
  authenticated.value = fortnoxAuthService.authenticated;
};

const { handleEvents, state } = useFortnoxAccountHandlerLogic({
  authenticated,
  account,
});

onMounted(loadData);
</script>

<template>
  <FortnoxAccountHandlerView :state="state" @event="handleEvents" />
</template>
